import {
    AggregateFunctions,
    ApiQueryEndpoints,
    Filter,
    FilterOperators,
} from "~/modules/filters/types";
import {
    LegendProps,
    NavigatorControlState,
    VisualizationConfig,
    VisualizationMode,
    VisualizationModeTypes,
} from "~/modules/visualization/components/Timeseries/types";
import { ASSET_TIMESERIES_V4_API_TOOLS_CONTROLS } from "~/modules/visualization/components/Timeseries/consts";
import {
    AssetTimeseriesColumns,
    AssetTimeseriesGroupBy,
} from "~/modules/asset_timeseries_v4/types";
import { ExportTableNames } from "~/modules/downloads/types";

// // // //

const visualizationConfig: VisualizationConfig = {
    area: false,
    enableZoom: false,
    showTotal: false,
    height: 350,
    yAxis: {
        min: undefined,
    },
    legend: {
        itemWidth: 125,
        layout: "vertical",
        align: "right",
        verticalAlign: "top",
    },
    linePlotOptions: {
        marker: {
            enabled: false,
            states: {
                hover: {
                    enabled: true,
                },
            },
        },
    },
};

// // // //

export function getApyChart(props: {
    key: string;
    label: string;
    filters: Filter[];
    defaultGroupBy?: AssetTimeseriesGroupBy;
    enableGroupByControls?: boolean;
    measureSlug: string;
    groupLimit?: number;
    legend?: LegendProps;
    navigator?: NavigatorControlState;
    height?: number;
    loginRequired?: boolean;
}): VisualizationMode {
    const {
        key,
        label,
        filters,
        enableGroupByControls = true,
        defaultGroupBy = AssetTimeseriesGroupBy.asset,
        measureSlug,
        groupLimit,
        legend = visualizationConfig.legend,
        navigator = {
            enabled: true,
            active: true,
            forceUpdate: true,
        },
        height,
        loginRequired = true,
    } = props;
    return {
        key,
        type: VisualizationModeTypes.apy,
        endpoint: ApiQueryEndpoints.AssetTimeseriesV4,
        loginRequired: loginRequired,
        content: {
            label,
        },
        queryControls: {
            groupBy: {
                enabled: enableGroupByControls,
                forceUpdate: true,
                value: defaultGroupBy,
                allowedOptions: [
                    AssetTimeseriesGroupBy.asset,
                    AssetTimeseriesGroupBy.issuer,
                    AssetTimeseriesGroupBy.jurisdictionCountry,
                ],
            },
        },
        visualizationConfig: {
            ...visualizationConfig,
            legend,
            ...(height !== undefined && { height }),
        },
        visualizationControls: {
            stacked: {
                enabled: false,
                active: false,
                forceUpdate: true,
            },
            legend: {
                enabled: true,
                active: true,
                forceUpdate: true,
            },
            navigator: {
                ...navigator,
            },
        },
        query: {
            aggregate: {
                aggregateFunction: AggregateFunctions.Sum,
                groupBy: defaultGroupBy,
                groupLimit,
            },
            filter: {
                operator: FilterOperators.And,
                filters: [
                    ...filters,
                    {
                        field: AssetTimeseriesColumns.measureSlug,
                        operator: FilterOperators.Equals,
                        value: measureSlug,
                    },
                ],
            },
            sort: {
                direction: "asc",
                field: "date",
            },
            pagination: {
                page: 1,
                perPage: 25,
            },
        },
        apiTools: ASSET_TIMESERIES_V4_API_TOOLS_CONTROLS,
        dataExportControls: {
            enabled: true,
            filename: key,
            exportTableName: ExportTableNames.asset_timeseries_v4,
        },
    };
}
